import { render, staticRenderFns } from "./GetKey.vue?vue&type=template&id=5f31fc20&scoped=true&"
import script from "./GetKey.vue?vue&type=script&lang=js&"
export * from "./GetKey.vue?vue&type=script&lang=js&"
import style0 from "./GetKey.vue?vue&type=style&index=0&id=5f31fc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31fc20",
  null
  
)

export default component.exports